var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVariance(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "20px",
    viewBox: "0 -960 960 960",
    width: "20px",
    fill: "#DDDDDD",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122-223q-11-11-11.5-25.5T121-274l205-205q21-21 51-21t51 21l101 101 212-211h-81q-15.3 0-25.65-10.29Q624-609.58 624-624.79t10.35-25.71Q644.7-661 660-661h168q15.3 0 25.65 10.35Q864-640.3 864-625v168q0 15.3-10.29 25.65Q843.42-421 828.21-421t-25.71-10.06Q792-441.13 792-456v-82L580-326q-21 21-51 21t-51-21L377-428 173-223q-11 11-25.5 11T122-223Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVariance);
export default __webpack_public_path__ + "static/media/Variance.6b92e92520e25a1c391098c54d5d6cc8.svg";
export { ForwardRef as ReactComponent };